export default __webpack_public_path__ + "static/media/bookLoveFullCircle.9d5bb924.jpg";